import React from 'react';

import { compose, createStore, applyMiddleware } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import thunk from 'redux-thunk';
import rootReducer from './redux/reducers/index'
import AsyncStorage from '@react-native-community/async-storage'

const pathname = window.location.pathname;   // TODO::: detectar mejor en otro lado
const codeClient = pathname.split('/')[1];   // TODO::: detectar mejor en otro lado

const persistConfig = {
    key : 'ViCo_' + codeClient,
    storage : AsyncStorage,
    whitelist : [
        'hotelReducer',
        'profileReducer',
        'checkInReducer',
        'requestsReducer'
    ],
    blacklist : [
        
    ]
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistedReducer = persistReducer(persistConfig, rootReducer)

const middlewares = [
    thunk,
    // __DEV__ && createLogger(),
].filter(Boolean);
const store = createStore(persistedReducer, composeEnhancers(applyMiddleware(...middlewares)))

const persistor = persistStore(store)

export { persistor, store };